export default "__VITE_ASSET___UszxW4K__"